import { Action, createActions } from 'redux-actions';
import { Voucher } from '../../../Voucher/types';

export const ADD_VOUCHER = 'ADD_VOUCHER';
export const REMOVE_VOUCHER = 'REMOVE_VOUCHER';
export const SET_VOUCHER = 'SET_VOUCHER';

export type SetVoucherAction = Action<Voucher>;

export const { removeVoucher, setVoucher } = createActions({
	[REMOVE_VOUCHER]: () => {},
	[SET_VOUCHER]: (voucher: Voucher) => voucher
});
